export default __webpack_public_path__ + "static/media/tete93.9f603489.png";